// extracted by mini-css-extract-plugin
export var container = "_81-0";
export var error = "_81-9";
export var label = "_81-5";
export var light = "_81-6";
export var md = "_81-3";
export var sm = "_81-2";
export var thin = "_81-8";
export var thinBold = "_81-7";
export var vertical = "_81-4";
export var xs = "_81-1";